import produce from "immer";
import create from "zustand";
export type AppModalType =
  | "men"
  | "women"
  | "mobile"
  | "search"
  | "cart"
  | "about"
  | "buy1get1"
  | "none";
export interface AppState {
  isDarkTheme: boolean;
  isLoading: boolean;
  modal?: AppModalType;
  headerSpacing?: number;
  headerColorInverted?: boolean;
  showHeadlineBanner?: 0 | 1 | 2;
  setModal: (name: AppModalType) => void;
}
export const useHeaderStore = create<AppState>()((set) => ({
  isDarkTheme: false,
  isLoading: false,
  modal: "none",
  headerSpacing: 0,
  headerColorInverted: false,
  showHeadlineBanner: 2,

  setModal: (name: AppModalType) =>
    set(
      produce((state) => {
        state.modal = name;
      })
    ),
}));
